<template>
    <Select
        v-model="model"
        :items="translatedCountriesList"
        :placeholder="translate('country_select.select_country')"
        :search-placeholder="translate('country_select.search_country')"
        :no-results-text="translate('country_select.no_countries_found')"
        item-key="code"
        :searchable="true"
        :dropdown-mode="dropdownMode"
        :aria-label="translate('country_select.select_country')"
    >
        <template v-slot:selected-item="{ selectedItem }">
            <div class="select-selected-content" v-if="selectedItem">
                <span :class="['flag-icon', 'flag-icon-' + selectedItem.code.toLowerCase()]" aria-hidden="true"></span>
                <span class="select-item-label">{{ selectedItem.name }}</span>
            </div>
        </template>

        <template v-slot:item="{ item }">
            <div class="country-item">
                <span :class="['flag-icon', 'flag-icon-' + item.code.toLowerCase()]" aria-hidden="true"></span>
                <span class="select-item-label">{{ item.name }}</span>
            </div>
        </template>

        <template v-slot:no-results>
            <span class="icon" aria-hidden="true">
                <i class="fas fa-exclamation-triangle"></i>
            </span>
            <span>{{ translate("country_select.no_countries_found") }}</span>
        </template>
    </Select>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { translate } from "./translations";
    import countries from "../Common/countries.json";
    import Select from "./Select.vue";

    const model = defineModel<string | null>();

    const props = defineProps<{
        dropdownMode?: "absolute" | "container";
        availableCountries?: string[];
    }>();

    const translatedCountriesList = computed(() => {
        let countriesToShow = countries;

        // If availableCountries prop is provided and not empty, filter the countries
        if (props.availableCountries && props.availableCountries.length > 0) {
            countriesToShow = countries.filter(country => props.availableCountries!.includes(country.code));
        }

        return countriesToShow.map(countryData => {
            return {
                code: countryData.code,
                name: translate("country." + countryData.code.toUpperCase()),
            };
        });
    });
</script>

<style scoped>
    .country-item {
        display: flex;
        align-items: center;
        gap: 0.5em;
        color: inherit;
    }
</style>
